/**
 * @generated SignedSource<<f9b738d12a20a1b7fe56cf4b38e86ac1>>
 * @relayHash 17ed6464b32619a274982be7d610369f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ef2b60415898b3aa402166cc7720f109119c31148cac81ede6c004ec20b1ca7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type viewKBSpacesQuery$variables = {
  cloudId: string;
  container: string;
};
export type viewKBSpacesQuery$data = {
  readonly knowledgeBase: {
    readonly knowledgeBase: {
      readonly __typename: "KnowledgeBaseSources";
      readonly edge: ReadonlyArray<{
        readonly node: {
          readonly entityReference: string;
          readonly name: string;
        };
      } | null | undefined>;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type viewKBSpacesQuery = {
  response: viewKBSpacesQuery$data;
  variables: viewKBSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "container"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "container",
    "variableName": "container"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "entityReference"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "viewKBSpacesQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeBaseSourceEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "viewKBSpacesQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeBaseSourceEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9ef2b60415898b3aa402166cc7720f109119c31148cac81ede6c004ec20b1ca7",
    "metadata": {},
    "name": "viewKBSpacesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0960c1971ae57c2404a0c0edbb506f9e";

export default node;
